//  LEGACY DEPLOYMENT
//
// export const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
//   authDomain: 'form-poll.firebaseapp.com',
//   databaseURL: 'https://form-poll.firebaseio.com',
//   projectId: 'form-poll',
//   storageBucket: 'form-poll.appspot.com',
//   messagingSenderId: '569094741476',
//   appId: '1:569094741476:web:a92e0a7cd3da3d6eb3bbf1',
//   measurementId: 'G-CQ298VTTJN'
// };


export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: "formpoll.firebaseapp.com",
  databaseURL: "https://formpoll.firebaseio.com",
  projectId: "formpoll",
  storageBucket: "formpoll.appspot.com",
  messagingSenderId: "861631058111",
  appId: "1:861631058111:web:ad9fdd6788098c4575360a",
  measurementId: "G-3ZE1Y4YCDP"
};
